module.exports = __webpack_public_path__ + "static/media/AvenirRegular.eecd612f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/AvenirRegular.woff2
// module id = 181
// module chunks = 0